import { AuthClientError, AuthClientEvent } from '@react-keycloak/core'

export interface KeycloakEventAuthClient {
    updateToken: (minValidity: number) => PromiseLike<boolean>
    login: () => PromiseLike<void>
}

export const handleKeycloakEvent = (
    event: AuthClientEvent,
    authClient: KeycloakEventAuthClient,
    error?: AuthClientError,
): void => {
    if (error) {
        console.log('onKeycloakEvent', event, error)
    }

    if (event === 'onTokenExpired') {
        // keycloak-js rejects with boolean `true` instead of an Error. Swallow it so Sentry
        // does not report "Non-Error promise rejection captured with value: true".
        authClient.updateToken(5).then(
            () => undefined,
            () => undefined,
        )
        return
    }

    if (event === 'onAuthRefreshError') {
        void authClient.login()
    }
}
